import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient'; // Adjust path as needed
import { UserAuth } from './AuthContext'; // Your custom context
import { useNavigate } from 'react-router-dom';

const CreatePostButton = () => {
  const { session } = UserAuth();
  const [user, setUser] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate()

  useEffect(() => {
    const getUser = async () => {
      const currentSession = await session;
      if (currentSession?.user) {
        setUser(currentSession.user);
      }
    };
    getUser();
  }, [session]);

  const handlePostSubmit = async () => {

    navigate('/post')
    // e.preventDefault();
    // setMessage('');

    // const { error } = await supabase.from('posts').insert([
    //   {
    //     title,
    //     content,
    //     user_id: user.id,
    //   },
    // ]);

    // if (error) {
    //   console.error(error);
    //   setMessage('حدث خطأ أثناء إنشاء المنشور');
    // } else {
    //   setMessage('تم إنشاء المنشور بنجاح');
    //   setTitle('');
    //   setContent('');
    //   setShowForm(false);
    // }
  };

  if (!user) return null;

  return (
    <>
      {/* Sticky Button */}
      <div
        className={`fixed top-1/2 left-0 transform -translate-y-1/2 z-50 transition-all duration-300`}
        onMouseEnter={() => setShowForm(true)}
        onMouseLeave={() => setShowForm(false)}
      >
        <div
        onClick={handlePostSubmit}
          className={`bg-blue-700 text-white px-4 py-2 rounded-r cursor-pointer transition-all duration-300 ${
            showForm ? 'w-48' : 'w-10'
          }`}
        >
          ✏️ {showForm && <span className="ml-2">إنشاء منشور</span>}
        </div>
      </div>

      {/* Form Modal */}
      {showForm && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-40 z-40">
          <div className="bg-white rounded shadow-lg p-6 w-full max-w-md rtl text-right">
            <h2 className="text-xl font-bold mb-4">إنشاء منشور جديد</h2>
            {/* <form onSubmit={handlePostSubmit}>
              <div className="mb-4">
                <label className="block mb-1">العنوان</label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="w-full border border-gray-300 px-3 py-2 rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1">المحتوى</label>
                <textarea
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  className="w-full border border-gray-300 px-3 py-2 rounded"
                  required
                />
              </div>
              {message && <div className="mb-2 text-green-600">{message}</div>}
              <div className="flex justify-between mt-4">
                <button
                  type="submit"
                  className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800"
                >
                  نشر
                </button>
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  className="text-red-600"
                >
                  إلغاء
                </button>
              </div>
            </form> */}
          </div>
        </div>
      )}
    </>
  );
};

export default CreatePostButton;
